<template>
    <v-layout class="component-wrap">
        <training-management />
    </v-layout>
</template>

<script>
import TrainingManagement  from '@/components/view_blocks/Training_management/Training_management_wrap.vue';

export default {
  components: {
    TrainingManagement,
  },
};
</script>
